var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{staticClass:"gl-w-full @sm/panel:!gl-ml-3 @sm/panel:gl-w-auto",attrs:{"loading":_vm.isResolving},on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._v("\n  "+_vm._s(_vm.buttonTitle)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }